<template>
  <v-container fluid style="padding: 0;background-color: #ffffff;height: 93vh;">
    <v-dialog
      v-model="startDateDialog"
      max-width="338px"
      @click="startDateDialog = !startDateDialog"
    >
      <v-card>
        <v-card-title>
          <span>Intervalo de Datas</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="startDatePicker"
            type="month"
            locale="pt-br"
            @change="(newDate) => selectDateCalendar(newDate)"
            range
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="clearDateCalendar()">
            Limpar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="startDateDialog = !startDateDialog"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <div class="grid-container">
        <div class="component item1" style="position: relative;">
          <v-overlay absolute style="opacity: 0.8" :value="loading.KPIData">
            <v-progress-circular indeterminate color="primary" v-if="loading.KPIData"></v-progress-circular>
          </v-overlay>
          <WaterUsageChart 
            style="height: 100%;" 
            :startDate="nextReadingDates.initialReadingDateEstimated" 
            :endDate="nextReadingDates.nextScheduledReadingDateEstimated"
            :targetValue="targetValue"
            :dailyData="waterUsageData"
            :weeklyData="waterUsageWeeklyData"
            :monthlyData="waterUsageMonthlyData"
          />
        </div>
        <div class="component item2">
          <DoughnutAlertCard 
            style="height: 100%;" 
                iconType="image"
                :icon="priorityHighIcon"
                :iconBG=true
                title="Últimos Alertas Ativos"
                :alerts="alertsData"
              />
        </div>
        <div class="component item3">
          <DoughnutGoalCard 
                style="height: 100%;" 
                iconType="image"
                :icon="targetIcon"
                :iconBG=true
                title="Meta de Consumo Mensal"
                :readingStartDate="nextReadingDates.initialReadingDateEstimated"
                :readingEndDate="nextReadingDates.nextScheduledReadingDateEstimated"
                :goal="currentConsumption.getGoalEconomyCubicMeters"
                :measured="currentConsumption.totalWaterMeasuredTotal"
                :estimated="currentConsumption.totalWaterEstimatedTotal"
              />
        </div>
        <div class="component item4a">
          <KpiCard  
            style="height: 100%;display: flex;justify-content: space-between;" 
            iconType="image"
            :icon="require('@/../src/assets/dashboard/expand_content.png')"
            :value="KPIData.totalFinancialEconomy"
            :subtitle="KPIData.installationDate"
            title="Economia"
            :loading="loading.KPIData"
            :color="'#E0EFFF'"
            :progress="100">
              <template #value>
                <div class="economy-summary-card">
                  <div class="economy-summary-row">
                    <span>Acumulada</span>
                    <strong>{{ econometerData.totalFinancialEconomy }}</strong>
                  </div>
                  <div class="economy-summary-row">
                    <span>Média</span>
                    <strong>{{ econometerData.avaregeFinancialEconomy }}</strong>
                  </div>
                </div>
              </template>
          </KpiCard>
        </div>
          <div class="component item4b">
            <KpiCard   
              style="height: 100%;display: flex;justify-content: space-between;" 
              iconType="image"
              :icon="require('@/../src/assets/dashboard/expand_content.png')"
              :value="KPIData.lastDateReading"
              :subtitle="dashboardHasBaselineConfig ? dashboardGoalModeLabel : nextReadingDates.monthYear"
              title="Meta da Baseline"
              :loading="loading.KPIData"
              :color="'#E0EFFF'"
              :progress="100">
              <template #value>
                <div v-if="dashboardHasBaselineConfig" class="baseline-summary-card">
                  <div class="baseline-summary-row baseline-summary-row--total">
                    <span>Total</span>
                    <strong>{{ formatVolume(dashboardGoalBreakdown.total) }}</strong>
                  </div>
                  <div class="baseline-summary-grid">
                    <div>
                      <span>Água</span>
                      <strong>{{ formatVolume(dashboardGoalBreakdown.water) }}</strong>
                    </div>
                    <div>
                      <span>Efluentes</span>
                      <strong>{{ formatVolume(dashboardGoalBreakdown.sewer) }}</strong>
                    </div>
                  </div>
                </div>
                <div v-else class="baseline-empty-state">
                  Unidade sem baseline configurada.
                </div>
              </template>
            </KpiCard>
          </div>
        <div class="component item4c">
          <KpiCard
              style="height: 100%;display: flex;justify-content: space-between;"  
              iconType="image"
              :icon="require('@/../src/assets/dashboard/expand_content.png')"
              :value="KPIData.goalEconomy"
              title="Meta de Consumo diária"
              :loading="loading.KPIData"
              :color="KPIDataColor.lastDateReading"
              :subtitle="nextReadingDates.monthYear"
              :progress="100">
              <template #value>
                <div style="display: flex; align-items: flex-end;">
                  <div class="typographyKPI" style="color: #4092FF;">{{ KPIData.goalEconomy }}</div>
                  <div class="typographyKPISub" style="margin-left: 4px;">/dia</div>
                </div>
              </template>
            </KpiCard>
          </div>
          <div class="component item5">
            <carousel 
              :slides="impactCarouselSlides"
              style="height: 100%;width: 100%;" 
            />
          </div>
        <v-col v-if="!hasUnits">
          <v-card>
            <v-card-title>Sem dados para exibir.</v-card-title>
            <v-card-text>Aqui aparecerá os dados das unidades de seus clientes.</v-card-text>
          </v-card>
        </v-col>
      </div>
  </v-container>
</template>
<script>
import DashboardScript from "./DashboardScript";
export default DashboardScript;
</script>
<style scoped>
.boxChartsAutoHeighFirstLine {
  border: 1px solid #9fa8da75;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: calc(100vh - 57vh);
  min-height: 300px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  padding: 15px;
}
.boxChartsAutoHeigh {
  border: 1px solid #9fa8da75;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: calc(100vh - 69vh);
  min-height: 250px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  padding: 15px;
}
.impact-data {
  padding: 16px 8px;
  text-align: left;
}
.impact-item p {
  margin-bottom: 6px;
}
.impact-detail {
  margin-left: 12px;
}
.highlight {
  color: #1976d2;
  font-weight: bold;
}
.impact-line {
  border-left: 3px solid #1976d2;
  padding-left: 10px;
  margin-bottom: 12px;
}
.typographyKPI{
  color: #1C1C1C;
  font-family: Manrope;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.typographyKPISub{
  text-align: center;
  font-family: Manrope;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #B5B5B7;
}
.economy-summary-card,
.baseline-summary-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.economy-summary-row,
.baseline-summary-row,
.baseline-summary-grid > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.economy-summary-row span,
.baseline-summary-row span,
.baseline-summary-grid span {
  color: #545454;
  font-family: Manrope;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.economy-summary-row strong,
.baseline-summary-row strong,
.baseline-summary-grid strong {
  color: #1C1C1C;
  font-family: Manrope;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.baseline-summary-row--total strong {
  color: #4092FF;
  font-size: 15px;
}

.baseline-summary-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
}

.baseline-empty-state {
  color: #545454;
  font-family: Manrope;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 18px;
  height: 87vh;
  padding: 20px;
}

.component {
  flex-wrap: wrap;
  min-width: 0;
  word-break: break-word;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 16px;
  padding: 2px;
  color: white;
}

.item1 {
  max-height: 100%;
  grid-column: 1 / span 4;
  grid-row: 1 / span 2;                       
}

.item2 {
  grid-column: 1 / span 2;
  grid-row: 3 / span 2;
}

.item3 {
  grid-column: 3 / span 2;
  grid-row: 3 / span 2;
}

.item4a {
  grid-column: 5 / span 1;
  grid-row: 1;
}

.item4b {
  grid-column: 5 / span 1;
  grid-row: 2;
}

.item4c {
  grid-column: 5 / span 1;
  grid-row: 3;
}

.item5 {
  grid-column: 5 / span 1;
  grid-row: 4;
}

</style>
